import ConfirmDeleteModal from "pages/ManagementPage/questionSection/ConfirmDeleteModal/ConfirmDeleteModal";

export default ConfirmDeleteModal;
